module.exports = __webpack_public_path__ + "assets/media/day17.8bec9f9f.mp3";